import { render, staticRenderFns } from "./DeliveryConfirmation.vue?vue&type=template&id=63de2037&scoped=true&"
import script from "./DeliveryConfirmation_.js?vue&type=script&lang=js&"
export * from "./DeliveryConfirmation_.js?vue&type=script&lang=js&"
import style0 from "./DeliveryConfirmation.vue?vue&type=style&index=0&id=63de2037&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de2037",
  null
  
)

export default component.exports